import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import {
  Button,
  Progress,
  Row,
  Col,
  Form,
  Input,
  Modal,
  Divider,
  Select,
  Typography,
  Tag,
  Card,
} from "antd";
import { BankOutlined, DeleteOutlined } from "@ant-design/icons";
import Main from "../../components/layout/Main";
import BankImage from "../../assets/images/bank-image-main.svg";
import IICONimage from "../../assets/images/i-icon-mainhj.svg";
import CheckImage from "../../assets/images/check-orange-image.svg";
import { useWallet } from "../../context/WalletContext";
import UniversalModal from "../../components/UniversalModal";
const { Text } = Typography;

const BankCard = ({ bank, onSetPrimary, onDelete }) => {
  return (
    <Card
      className="bank-card"
      bordered={false}
      style={{
        borderRadius: "12px",
        marginBottom: "16px",
        background: "rgba(255,255,255,0.05)",
      }}
    >
      <div className="bank_name_class_kj">
        <BankOutlined style={{ fontSize: 28, color: "#1E90FF" }} />
        <div className="bank_name_class_kj_majk">
          <h4>{bank.bankName}</h4>
          {bank.isDefault && (
            <Tag className="for_primary_bank_accountt">Primary</Tag>
          )}
        </div>
      </div>
      <Text style={{ color: "#ccc", display: "block" }}>
        Account: {bank.accountNumber}
      </Text>
      <Text style={{ color: "#ccc", display: "block" }}>IBAN: {bank.iban}</Text>
      {!bank.isDefault && (
        <Text
          style={{ color: "#1890ff", cursor: "pointer" }}
          onClick={() => onSetPrimary(bank._id)}
        >
          Set as Primary
        </Text>
      )}

      <div className="main_new-deleteoutkj">
        <DeleteOutlined
          style={{ fontSize: 22, color: "red", cursor: "pointer" }}
          onClick={() => onDelete({ open: true, bankId: bank._id })}
        />
      </div>
    </Card>
  );
};

const WithdrawToken = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const {
    addBankDetails,
    loadBankDetails,
    withdrawAmount,
    makePrimaryBank,
    deleteBankDetails,
    loadWalletSummary,
  } = useWallet();
  const [withDrawModal, setConfirmWithdrawModal] = useState(false);
  const walletSummaryData = JSON.parse(localStorage.getItem("walletSummary"));
  const [bankDetailsForm, setBankDetailsForm] = useState(false);
  const [addBankModal, setAddBankModal] = useState(false);
  const [bankDetails, setBankDetails] = useState([]);
  const navigate = useNavigate();
  const [isDeleteBankModal, setIsDeleteBankModal] = useState({
    open: false,
    bankId: "",
  });
  const [form] = Form.useForm();

  const [withdrawDetails, setWithDrawDetails] = useState({
    amount: "",
    bankDetailId: "",
    bankName: "",
    accountNumber: "",
  });

  // ---------- handlers ------------

  const fetchBankDetails = async () => {
    const response = await loadBankDetails();
    if (response?.success) {
      setBankDetails(response.data.bankDetails);
    }
  };

  const handleFinish = async () => {
    let data = form.getFieldsValue();
    if (bankDetails.length === 0) {
      data.isDefault = true;
    }
    const response = await addBankDetails(data);
    if (response?.success) {
      setAddBankModal(true);
      fetchBankDetails();
      form.resetFields();
    }
  };

  const confirmWithdrawal = async () => {
    const data = {
      amount: withdrawDetails.amount,
      bankDetailId: withdrawDetails.bankDetailId,
      notes: `Withdraw ${withdrawDetails.amount} TKN from ${withdrawDetails.bankName}`,
    };
    const response = await withdrawAmount(data);
    if (response?.success) {
      setIsModalVisible(false);
      setConfirmWithdrawModal(true);
      form.resetFields();
      loadWalletSummary();
    }
  };

  const handleWithdrawSubmit = (e) => {
    e.preventDefault();
    if (!withdrawDetails.bankDetailId) {
      alert("Please select your bank");
      return;
    }

    setIsModalVisible(true);
    // do your withdraw action here
  };

  const handleMakePrimary = async (bankId) => {
    const response = await makePrimaryBank({
      bankDetailId: bankId,
      isDefault: true,
    });
    if (response?.success) {
      fetchBankDetails();
    }
  };

  const handleDeleteBank = async (bankId) => {
    const response = await deleteBankDetails(bankId);
    if (response?.success) {
      setIsDeleteBankModal({
        open: false,
        bankId: "",
      });
      fetchBankDetails();
    }
  };

  // ------------------- use effect --------------------
  useEffect(() => {
    fetchBankDetails();
  }, []);
  useEffect(() => {
    if (bankDetails.length > 0) {
      const defaultBank = bankDetails.find((bank) => bank.isDefault);
      if (defaultBank) {
        setWithDrawDetails((prev) => ({
          ...prev,
          bankDetailId: defaultBank._id,
          bankName: defaultBank.bankName,
          accountNumber: defaultBank.accountNumber,
        }));
      }
    }
  }, [bankDetails]);
  return (
    <Main>
      <h2 className="withdraw-title" style={{ color: "white" }}>
        {bankDetailsForm ? "Add Bank Details" : "Withdraw Amount"}
      </h2>
      {/* ------------- withdraw amount -------------- */}
      {!bankDetailsForm && (
        <form onSubmit={handleWithdrawSubmit}>
          <Row gutter={24}>
            <Col xs={24} md={14}>
              <div class="withdraw-amount-form-item mt-2">
                <label for="amount">Amount to Withdraw</label>
                <div class="input-wrapper">
                  <input
                    type="number"
                    id="amount"
                    name="amount"
                    value={withdrawDetails.amount}
                    onChange={(e) =>
                      setWithDrawDetails({
                        ...withdrawDetails,
                        amount: e.target.value,
                      })
                    }
                    placeholder="0"
                    required
                    style={{
                      backgroundColor: "black",
                      width: "100%",
                      height: "50px",
                      borderRadius: "9px",
                      marginBottom: "10px",
                      border: "none",
                      color: "white",
                      border: "1px solid rgba(255, 255, 255, 0.3)",
                      padding: "0 10px",
                      boxSizing: "border-box",
                    }}
                  />
                </div>
              </div>
              <div className="available-tokenn mt-2">
                Available:{" "}
                <span>{walletSummaryData?.wallet?.total_balance} TKN</span>
              </div>
              <div className="mt-3">
                <label style={{ display: "block", marginBottom: "8px" }}>
                  Select Bank
                </label>
                <div>
                  <select
                    className="withdraw-dropdown-select"
                    value={withdrawDetails.bankDetailId}
                    onChange={(e) => {
                      const selectedBank = bankDetails.find(
                        (bank) => bank._id === e.target.value
                      );

                      if (selectedBank) {
                        setWithDrawDetails({
                          ...withdrawDetails,
                          bankDetailId: selectedBank._id,
                          bankName: selectedBank.bankName,
                          accountNumber: selectedBank.accountNumber,
                        });
                      }
                    }}
                  >
                    <option value="" disabled>
                      Choose Bank
                    </option>
                    {bankDetails.map((bank, index) => (
                      <option key={index} value={bank._id}>
                        {bank.bankName}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="send-token-image mt-3">
                <Button
                  className="token-send-button Fill-button"
                  htmlType="submit"
                >
                  Withdraw Amount
                </Button>
              </div>
            </Col>
          </Row>
        </form>
      )}
      <Row>
        <Col span={24} md={14}>
          <Button
            className="Fill-button-small for_addbank_button"
            onClick={() => setBankDetailsForm((prev) => !prev)}
          >
            {bankDetailsForm ? "close form" : "Add bank"}
          </Button>
        </Col>
      </Row>

      {bankDetailsForm && (
        <div className="wallet-page">
          <Form
            form={form}
            layout="vertical"
            className="withdraw-form"
            onFinish={handleFinish}
          >
            <Row gutter={24}>
              {/* LEFT SIDE */}
              <Col xs={24} md={14}>
                <div className="withdraw-method-label">Bank Details</div>
                <Form.Item
                  name="fullName"
                  rules={[
                    {
                      required: true,
                      message: "Please enter your full name",
                    },
                    {
                      validator: (_, value) => {
                        if (value && value.trim() !== "") {
                          return Promise.resolve();
                        }
                        return Promise.reject(
                          new Error("Full name cannot be empty or just spaces")
                        );
                      },
                    },
                  ]}
                >
                  <Input placeholder="Full Name" className="withdraw-input" />
                </Form.Item>

                <Form.Item
                  name="bankName"
                  rules={[
                    { required: true, message: "Please enter your bank name" },
                    {
                      validator: (_, value) => {
                        if (value && value.trim() !== "") {
                          return Promise.resolve();
                        }
                        return Promise.reject(
                          new Error("Bank name cannot be empty or just spaces")
                        );
                      },
                    },
                  ]}
                >
                  <Input placeholder="Bank Name" className="withdraw-input" />
                </Form.Item>

                <Form.Item
                  name="accountNumber"
                  rules={[
                    {
                      required: true,
                      message: "Please enter your account number",
                    },
                    {
                      validator: (_, value) => {
                        if (value && value.trim() !== "") {
                          return Promise.resolve();
                        }
                        return Promise.reject(
                          new Error(
                            "Account number cannot be empty or just spaces"
                          )
                        );
                      },
                    },
                  ]}
                >
                  <Input
                    placeholder="Account Number"
                    className="withdraw-input"
                  />
                </Form.Item>

                <Form.Item
                  name="routingNumber"
                  rules={[
                    {
                      required: true,
                      message: "Please enter your routing number",
                    },
                    {
                      validator: (_, value) => {
                        if (value && value.trim() !== "") {
                          return Promise.resolve();
                        }
                        return Promise.reject(
                          new Error(
                            "Routing number cannot be empty or just spaces"
                          )
                        );
                      },
                    },
                  ]}
                >
                  <Input
                    placeholder="Routing Number"
                    className="withdraw-input"
                  />
                </Form.Item>

                <Form.Item
                  name="iban"
                  rules={[
                    {
                      required: true,
                      message: "Please enter your IBAN number",
                    },
                    {
                      validator: (_, value) => {
                        if (value && value.trim() !== "") {
                          return Promise.resolve();
                        }
                        return Promise.reject(
                          new Error(
                            "IBAN number cannot be empty or just spaces"
                          )
                        );
                      },
                    },
                  ]}
                >
                  <Input placeholder="IBAN Number" className="withdraw-input" />
                </Form.Item>

                <Form.Item
                  name="bankAddress"
                  rules={[
                    {
                      validator: (_, value) => {
                        if (!value || value.trim() === "") {
                          if (!value) return Promise.resolve();
                          return Promise.reject(
                            new Error("IBAN number cannot be only spaces")
                          );
                        }
                        return Promise.resolve();
                      },
                    },
                  ]}
                >
                  <Input
                    placeholder="Bank Address (optional)"
                    className="withdraw-input"
                  />
                </Form.Item>

                <Form.Item
                  name="ifscNumber"
                  rules={[
                    {
                      validator: (_, value) => {
                        if (!value || value.trim() === "") {
                          if (!value) return Promise.resolve();
                          return Promise.reject(
                            new Error("IFSC number cannot be only spaces")
                          );
                        }
                        return Promise.resolve();
                      },
                    },
                  ]}
                >
                  <Input
                    placeholder="IFSC Number (optional)"
                    className="withdraw-input"
                  />
                </Form.Item>

                <Form.Item
                  name="abaNumber"
                  rules={[
                    {
                      validator: (_, value) => {
                        if (!value || value.trim() === "") {
                          if (!value) return Promise.resolve();
                          return Promise.reject(
                            new Error("abaNumber number cannot be only spaces")
                          );
                        }
                        return Promise.resolve();
                      },
                    },
                  ]}
                >
                  <Input
                    placeholder="ABA Number (optional)"
                    className="withdraw-input"
                  />
                </Form.Item>
                <div className="send-token-image mt-5">
                  <Button
                    className="token-send-button Fill-button"
                    htmlType="submit"
                  >
                    Add Bank
                  </Button>
                </div>
              </Col>

              <Col span={24} md={8}>
                <div className="wallet-limits-card-inner">
                  <div className="header-wallet-proo">
                    <p>Sending Limit</p>
                    <h5>25%</h5>
                  </div>
                  <Progress
                    percent={25}
                    showInfo={false}
                    className="wallet-progress"
                  />
                  <p className="wallet-progress-label">
                    150 TKN remaining for gifts
                  </p>
                </div>
                <div className="bank_add_cardds">
                  {bankDetails.map((bank) => (
                    <BankCard
                      key={bank._id}
                      bank={bank}
                      onSetPrimary={() => handleMakePrimary(bank._id)}
                      onDelete={() =>
                        setIsDeleteBankModal({
                          open: true,
                          bankId: bank._id,
                        })
                      }
                    />
                  ))}
                </div>
              </Col>
            </Row>
          </Form>
        </div>
      )}

      {/* ------------ send withdrawal successfully modal -------------- */}
      <Modal
        open={isModalVisible}
        className="order-success-modal"
        onCancel={() => setIsModalVisible(false)}
        footer={null}
        closable
        width={452}
        centered
      >
        <h3 className="modal-title">Confirmation?</h3>

        <div className="modal-list-send">
          <h4>Amount</h4>
          <h3>{withdrawDetails.amount}</h3>
        </div>

        <div className="modal-list-send">
          <h4>Method</h4>
          <h3>Upayment</h3>
        </div>

        <div className="modal-list-send">
          <h4>Account</h4>
          <h3>{withDrawModal.accountNumber}</h3>
        </div>

        <Divider className="new-deviderhh" />

        <div className="modal-list-send">
          <h4>Network Fee</h4>
          <h3>
            {(withdrawDetails.amount * walletSummaryData.limits.feeIntrest) /
              100}{" "}
            KWD
          </h3>
        </div>

        <div className="modal-list-send">
          <h4>You’ll Receive</h4>
          <h3>
            {withdrawDetails.amount -
              (withdrawDetails.amount * walletSummaryData.limits.feeIntrest) /
                100}{" "}
            KWD
          </h3>
        </div>

        <Divider className="new-deviderhh" />

        <div className="modal-list-send">
          <h5>Total to Receive</h5>
          <h5>
            {" "}
            {withdrawDetails.amount -
              (withdrawDetails.amount * walletSummaryData.limits.feeIntrest) /
                100}{" "}
            KWD
          </h5>
        </div>

        <div className="daily-trabsfer-limiit">
          <img src={IICONimage} />
          <div className="daily-trabsfer-limiit-text">
            <p>
              Withdrawal usually takes 1-3 business days to complete. You'll
              receive a notification once the funds are transferred.
            </p>
          </div>
        </div>

        <div className="modal-footer12">
          <Button className="Fill-button" onClick={confirmWithdrawal}>
            Confirm Withdrawal
          </Button>
        </div>
      </Modal>
      {/* ------------- Add bank details and withdrawal successfully--------- */}
      <Modal
        open={addBankModal}
        onOk={() => setAddBankModal(false)}
        onCancel={() => setAddBankModal(false)}
        footer={null}
        width={452}
        centered
        className="ConfirmPaymentColor"
      >
        <div className="confirm-payement-modaal">
          <img src={CheckImage} />
          <h2>Confirmation</h2>
          <p>Add Bank Details Successful.</p>
          <div className="secess-modal-footer">
            <Button
              className="Fill-button-small"
              onClick={() => {
                setAddBankModal(false);
                navigate("/wallet");
              }}
            >
              Return to Wallet
            </Button>
            <Button
              className="light-button"
              onClick={() => {
                setAddBankModal(false);
                navigate("/stores");
              }}
            >
              Explore Store
            </Button>
          </div>
        </div>
      </Modal>
      {/* ------ With draw payment successfully -------- */}
      <Modal
        open={withDrawModal}
        onOk={() => setConfirmWithdrawModal(false)}
        onCancel={() => setConfirmWithdrawModal(false)}
        footer={null}
        width={452}
        centered
        className="ConfirmPaymentColor"
      >
        <div className="confirm-payement-modaal">
          <img src={CheckImage} />
          <h2>Withdraw Payment Successful</h2>
          <p>
            You’ve payment successfully sent your bank account whith in working
            days.
          </p>
          <div className="secess-modal-footer">
            <Button
              className="Fill-button-small"
              onClick={() => {
                setConfirmWithdrawModal(false);
                navigate(`/wallet`);
              }}
            >
              Return to Wallet
            </Button>
            <Button
              className="light-button"
              onClick={() => {
                setConfirmWithdrawModal(false);
                navigate(`/stores`);
              }}
            >
              Explore Store
            </Button>
          </div>
        </div>
      </Modal>
      {/* ----------- delete baknk detail modal --------- */}
      <UniversalModal
        open={isDeleteBankModal.open}
        onClose={() =>
          setIsDeleteBankModal({
            open: false,
            bankId: "",
          })
        }
        title="Are you sure ?"
        message=" Delete this bank detail"
        footerButtonLabel="Delete"
        onFooterButtonClick={() => handleDeleteBank(isDeleteBankModal.bankId)}
      />
    </Main>
  );
};

export default WithdrawToken;
